import script from "./SlideFade.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideFade.vue?vue&type=script&setup=true&lang=ts"

import "./SlideFade.vue?vue&type=style&index=0&id=1a998736&lang=css"

const __exports__ = script;

export default __exports__